<template>
  <v-container>
    <v-text-field
      :label="labels.name"
      v-model="user.name"
      @click:append="editarPerfil('nombre')"
      append-icon="edit"
      outline
      readonly
    ></v-text-field>

    <v-text-field
      :label="labels.cambiar_password"
      value="••••••••"
      append-icon="edit"
      @click:append="editarPerfil('contraseña')"
      outline
      readonly
    ></v-text-field>

    <v-text-field
      :label="labels.email"
      v-model="user.email"
      outline
      readonly
    ></v-text-field>
    
    <v-autocomplete
      :label="labels.campuses_a_cargo"
      v-model="user.campuses"
      :items="user.campuses"
      item-text="nombre"
      item-value="id"
      attach
      chips
      multiple
      outline
      readonly
    ></v-autocomplete>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Form from '~/mixins/form'

  export default {
    mixins: [Form],

    data: () => ({
      user: {
        name: null,
        email: null,
      }
    }),

    computed: mapGetters({
      auth: 'auth/user'
    }),

    mounted() {
      this.user = Object.assign(this.user, this.auth)
    },

    methods: {
      editarPerfil(campo) {
        this.$router.push({ name: "perfil-editar", params: { 'campo': campo } })
      }
    }
  }
</script>
